import { render, staticRenderFns } from "./OrdersIncoming.vue?vue&type=template&id=6b2655ac&scoped=true&"
import script from "./OrdersIncoming.vue?vue&type=script&lang=js&"
export * from "./OrdersIncoming.vue?vue&type=script&lang=js&"
import style0 from "./OrdersIncoming.vue?vue&type=style&index=0&id=6b2655ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2655ac",
  null
  
)

export default component.exports